import { PlainButton, TextInput } from "@jugl-web/ui-kit";
import { TableGridColumn } from "@jugl-web/ui-components/cross-platform/content/types";
import { cx, TFunction } from "@jugl-web/utils";
import { AutomationVariableDefinition } from "../../types";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";
import { RequestRowValueRichField } from "./components/RequestRowValueRichField";
import type { RequestRow } from "./types";

export type { RequestRow } from "./types";

const tdOverflowVisibleClassName = "[&>div]:!overflow-visible";

export const buildRequestKeyValueTableColumns = (
  t: TFunction,
  onChange: (next: RequestRow) => void,
  onDelete: (id: string) => void,
  supportedVariables: AutomationVariableDefinition[]
): TableGridColumn<RequestRow>[] => [
  {
    id: "key",
    title: t({
      id: "cx-actions-page.key",
      defaultMessage: "Key",
    }),
    grow: true,
    className: tdOverflowVisibleClassName,
    content: (row) => (
      <div className="w-full min-w-0">
        <TextInput
          placeholder={t({
            id: "common.enter",
            defaultMessage: "Enter",
          })}
          value={row.key}
          onChange={(e) =>
            onChange({ ...row, key: e.target.value.trimStart() })
          }
        />
      </div>
    ),
  },
  {
    id: "value",
    title: t({
      id: "cx-actions-page.value",
      defaultMessage: "Value",
    }),
    grow: true,
    className: tdOverflowVisibleClassName,
    content: (row) => (
      <div className="w-full min-w-0">
        <RequestRowValueRichField
          key={row.id}
          row={row}
          onChange={onChange}
          supportedVariables={supportedVariables}
        />
      </div>
    ),
  },
  {
    id: "action",
    title: t({
      id: "cx-actions-page.action",
      defaultMessage: "Action",
    }),
    width: 72,
    headerClassName: "[&>div]:justify-center",
    className: cx("[&>div]:justify-center", tdOverflowVisibleClassName),
    content: (row) => (
      <div className="flex w-full justify-center">
        <PlainButton
          type="button"
          onClick={() => onDelete(row.id)}
          className="flex h-8 w-8 items-center justify-center"
        >
          <TrashIcon />
        </PlainButton>
      </div>
    ),
  },
];
